import React from "react";

import KnowledgeBaseArticles, { ArticleDataT } from "../KnowledgeBaseArticles";
import PowurPlayVideos, { PowurPlayVideoT } from "../PowurPlayVideos";

import * as S from "./styles";

const proposalRequestArticles: ArticleDataT[] = [
  {
    key: "vision-proposal-tool",
    title: "The Vision Proposal Tool",
    detail: "Learn about the Vision Proposal Tool and how to use it effectively.",
    url: "https://help.powur.com/hc/en-us/articles/13241738808731-The-Vision-Proposal-Tool",
  },
  {
    key: "vision-proposal-tool-faq",
    title: "Vision Proposal Tool FAQ",
    detail: "Frequently asked questions about the Vision Proposal Tool.",
    url: "https://help.powur.com/hc/en-us/articles/24366556350107-Vision-Proposal-Tool-FAQ",
  },
  {
    key: "building-proposal-vision",
    title: "Building a Proposal in Vision",
    detail: "Step-by-step guide to building a proposal in Vision.",
    url: "https://help.powur.com/hc/en-us/articles/14209521671579-Building-a-Proposal-in-Vision",
  },
  {
    key: "powur-proposal",
    title: "The Powur Proposal",
    detail: "Overview of the Powur Proposal process and best practices.",
    url: "https://help.powur.com/hc/en-us/articles/9480067979163-The-Powur-Proposal",
  },
  {
    key: "vision-design-principles",
    title: "Vision Proposal Design Principles and Design Team Questions",
    detail: "Guidelines for designing effective proposals in Vision and common design team questions.",
    url: "https://help.powur.com/hc/en-us/articles/9479357106203-Vision-Proposal-Design-Principles-and-Design-Team-Questions",
  },
  {
    key: "finance-loan-matrix",
    title: "Powur's Finance Loan Product Matrix",
    detail: "Comprehensive guide to Powur's finance loan products.",
    url: "https://help.powur.com/hc/en-us/articles/27270961768219-Powur-s-Finance-Loan-Product-Matrix",
  },
  {
    key: "payment-options",
    title: "Comparing Cash, Financing, and TPO Payment Options",
    detail: "Analysis of different payment options available to homeowners.",
    url: "https://help.powur.com/hc/en-us/articles/19685176128539-Comparing-Cash-Financing-and-TPO-Payment-Options",
  },
];

const powurPlayVideoData: PowurPlayVideoT[] = [
  {
    key: "presenting-virtually",
    label: "Presenting Virtually with Andy Smith",
    image: "/img/presenting-virtually.png",
    url: "https://play.powur.com/movie/smith-presenting-virtually",
  },
  {
    key: "communicate-in-person",
    label: "Communicating With Homeowners in Person",
    image: "/img/communicate-in-person.png",
    url: "https://play.powur.com/movie/lonson-communicating-with-homeowners-in-person",
  },
  {
    key: "follow-up-strategies",
    label: "Follow-Up Strategies with Mike Rosenfeld",
    image: "/img/follow-up-strategies.png",
    url: "https://play.powur.com/movie/rosenfeld-follow-up-strategies",
  },
];

const RequestComplete = () => {
  return (
    <S.RequestCompleteContainer>
      <S.NoteHeader>Congratulations, we&apos;ve received your proposal request!</S.NoteHeader>
      <S.NoteDetails>
        <S.Paragraph>
          What happens next? Our Proposal Team will return your design based on the following timelines if requested
          within operating hours:
        </S.Paragraph>
        <ul>
          <li>
            <S.Bold>Standard Requests:</S.Bold> Within 1 hour.
          </li>
          <li>
            <S.Bold>Expedited Requests:</S.Bold> Within 30 minutes
          </li>
          <li>
            <S.Bold>Third-Party Ownership (TPO) Requests:</S.Bold> Within 1-4 hours.
          </li>
        </ul>
        <S.Paragraph>
          If you selected the &quot;Design Proposal Myself&quot; option, you can now start designing your proposal
          directly in Vision. Be sure to review all necessary details to ensure accuracy.
        </S.Paragraph>
        <S.Paragraph>
          Please note that requests submitted at the end of or outside operating hours will be attended to first thing
          the following day.
        </S.Paragraph>
        <S.Paragraph>
          <S.Bold sx={{ marginBottom: "16px" }}>Operating Hours:</S.Bold>
        </S.Paragraph>
        <ul>
          <li>Monday-Friday: 5 AM-8 PM PT</li>
          <li>Saturday-Sunday: 9 AM-8 PM PT</li>
          <li>Holidays: Varies</li>
        </ul>
        <S.Paragraph>
          In the meantime, stay connected with your homeowner to guide them through the process and prepare for the next
          phases of your project. Below, you&apos;ll find tips and best practices to help you achieve a successful
          contract and project completion.
        </S.Paragraph>
      </S.NoteDetails>
      <KnowledgeBaseArticles articleData={proposalRequestArticles} />
      <PowurPlayVideos videoData={powurPlayVideoData} />
    </S.RequestCompleteContainer>
  );
};

export default RequestComplete;
